import React, { useEffect, useState } from "react";
import {
  Box, Typography, TextField, Button, Grid,
  FormControl, InputLabel, Select, MenuItem,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";

import { createApplicationType, fetchJobs } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import { COMPANY_ID } from "../../config/appConfig";

export default function ApplicationTypeCreatePage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState("");
  const [form, setForm] = useState({
    applicationTypeName: "",
    applicationTypeDescription: "",
    url: "",
  });

  useEffect(() => {
    (async () => {
      try { setJobs(await fetchJobs(businessDomainId)); }
      catch (e) { /* jobs may be empty */ }
    })();
  }, [businessDomainId]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createApplicationType({
        ...form,
        companyId: COMPANY_ID,
        businessDomainId,
        jobId: selectedJob ? selectedJob.jobId : null,
        jobName: selectedJob ? selectedJob.jobName : null,
      });
      notify.success(t("message.create.success"));
      navigate(`/design/${businessDomainId}/application-types`);
    } catch (err) {
      notify.apiError(err);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t("applicationType.create.title")}
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              fullWidth required multiline
              label={t("applicationType.name")}
              name="applicationTypeName"
              value={form.applicationTypeName}
              onChange={handleChange}
            />
          </Grid>

          <Grid size={12}>
            <TextField
              fullWidth multiline rows={3}
              label={t("applicationType.description")}
              name="applicationTypeDescription"
              value={form.applicationTypeDescription}
              onChange={handleChange}
            />
          </Grid>

          <Grid size={12}>
            <FormControl fullWidth required>
              <InputLabel>{t("applicationType.job")}</InputLabel>
              <Select
                value={selectedJob}
                label={t("applicationType.job")}
                onChange={(e) => setSelectedJob(e.target.value)}
              >
                {jobs.map((job) => (
                  <MenuItem key={job.jobId} value={job}>
                    {job.jobName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid size={12}>
            <TextField
              fullWidth
              label={t("common.url")}
              name="url"
              value={form.url}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">
            {t("common.add")}
          </Button>
          <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/application-types`)}>
            {t("common.cancel")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
